<template>
	<div class="stream-navigation-heading">
		<h1 class="label">{{ label }}</h1>
	</div>
</template>

<script>

export default {
	name: "StreamNavigationHeading",
	props: {
		label: {
			type: String,
			required: true,
		},
	},
};
</script>

<style lang="scss" scoped>
$labelColor: $color2-500;

.stream-navigation-heading > .label {
	@include font-and-line-for(0);
	text-align: left;
	color: $labelColor;
}
</style>
